import { cn } from '../../helpers/shadCnUtils';

export function NewChip({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'border-brand-secondary-hover text-brand-secondary-hover absolute -top-2.5 -right-4 z-10 rounded-full border bg-teal-50 px-1.25 pt-0.5 text-[10px] font-bold',
        className,
      )}
    >
      NEW
    </span>
  );
}
